import axios from "axios";

export const state = {
    investmentreturns: [],
};

export const getters = {
    investmentreturns: state => state.investmentreturns,
};

export const mutations = {
    setInvestments(state, newValue) {
        state.investmentreturns = newValue
    },
};

export const actions = {
    async fetchInvestmentReturns({ commit }) {
        await axios.get('/investmentreturns').then(res => {
            commit('setInvestments', res.data.returns)
        })
    },
    async filterInvestmentReturns({commit}, {datefrom,dateto}) { 
        let formData = new FormData();
        formData.append("datefrom", datefrom);
        formData.append("dateto", dateto);
        let url = "/filterinvestmentreturns";
        await axios.post(url, formData).then((response) => {
            commit('setInvestments', response.data.returns)
        })
    },
};
